import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";
import { IconType } from "react-icons";

// Create a wrapper component for icons to fix TypeScript errors
const IconWrapper = ({ Icon }: { Icon: IconType }) => {
  // Using the component as any type to bypass TypeScript errors
  const IconComponent = Icon as any;
  return <IconComponent size={24} />;
};

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1 - Logo & Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Lifeline Foundation</h3>
            <p className="mb-4">
              Empowering women, educating communities, and promoting health
              through sustainable development initiatives.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-white hover:text-primary transition-colors"
              >
                <IconWrapper Icon={FaFacebook} />
              </a>
              <a
                href="#"
                className="text-white hover:text-primary transition-colors"
              >
                <IconWrapper Icon={FaTwitter} />
              </a>
              <a
                href="#"
                className="text-white hover:text-primary transition-colors"
              >
                <IconWrapper Icon={FaLinkedin} />
              </a>
            </div>
          </div>

          {/* Column 2 - Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <p className="mb-2">
              {" "}
              5/1136, Viram khand, Gomti Nagar, Lucknow 226010
            </p>
            <p className="mb-2">Tel. +91- 9919990009</p>
            <p className="mb-2">Email: lifelinef1999@gmail.com</p>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-primary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-primary transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/campaigns"
                  className="hover:text-primary transition-colors"
                >
                  Campaigns
                </Link>
              </li>
              <li>
                <Link
                  to="/donate"
                  className="hover:text-primary transition-colors"
                >
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Newsletter</h3>
            <p className="mb-4">
              Stay updated with our latest news and campaigns
            </p>
            <form className="flex flex-col space-y-2">
              <input
                type="email"
                placeholder="Your email"
                className="px-4 py-2 bg-gray-700 text-white rounded focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <button type="submit" className="btn-primary">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-700">
        <div className="container-custom py-6">
          <p className="text-center text-gray-400">
            &copy; {new Date().getFullYear()} Lifeline Foundation NGO. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
